import React from 'react';
import Botao from './Botao';

/** Paginacao — "Mostrando 1–8 de 10" à esquerda; anterior e próxima à direita. */
export default function Paginacao({ pagina, totalPaginas, total, porPagina, onMudar, rotulo = 'Mostrando' }) {
  if (!total) return null;
  const inicio = (pagina - 1) * porPagina + 1;
  const fim = Math.min(pagina * porPagina, total);

  return (
    <nav className="sj-paginacao" aria-label="Paginação">
      <span className="sj-num">{rotulo} {inicio}–{fim} de {total}</span>
      <div className="sj-paginacao__botoes">
        <Botao variante="secundario" tamanho="sm" disabled={pagina <= 1} onClick={() => onMudar(pagina - 1)}>Anterior</Botao>
        <Botao variante="secundario" tamanho="sm" disabled={pagina >= totalPaginas} onClick={() => onMudar(pagina + 1)}>Próxima</Botao>
      </div>
    </nav>
  );
}
